import { useEffect, useState } from "react";

export function useIsCoarsePointer(): boolean {
  const [isCoarse, setIsCoarse] = useState(false);

  useEffect(function watchPointerType() {
    const query = window.matchMedia("(pointer: coarse)");
    setIsCoarse(query.matches);

    function handleChange(event: MediaQueryListEvent) {
      setIsCoarse(event.matches);
    }

    query.addEventListener("change", handleChange);
    return function cleanup() {
      query.removeEventListener("change", handleChange);
    };
  }, []);

  return isCoarse;
}
